import { throwErrorWithId } from '@pypestream/utils';

import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';
import { getBotWithAssets } from '../../utils';

export const updateAssets = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{
  selectedBot: ProStudioContext['selectedBot'];
  cb?: (assets: { id: string; url: string }[]) => void;
} | void> => {
  let callback: ((assets: { id: string; url: string }[]) => void) | undefined;

  if (event.type === 'updateAssets') {
    callback = event.cb;
  }

  try {
    const { selectedBot, project } = ctx;

    const projectId = project?.id;

    if (!projectId) {
      throwErrorWithId('Project ID is required');
      return;
    }

    if (!selectedBot) {
      throwErrorWithId('Selected bot is required');
      return;
    }

    const botWithAssets = await getBotWithAssets({
      selectedBot,
      projectId,
    });

    return {
      selectedBot: botWithAssets,
      cb: callback,
    };
  } catch (error) {
    // Guarantee the promisified caller's cb settles exactly once even when the
    // asset fetch (or a guard) throws — otherwise a deferred Brand Moment Save
    // awaiting this cb would hang forever. cb([]) resolves the caller with an
    // empty asset list (→ null URL → its error guard); we still re-throw so the
    // machine's onError transition (#botFlowError) fires as before (PSTUDIO-3710).
    callback?.([]);
    throw error;
  }
};
